import { AuthService } from './main/auth.service';
import { HotelAuthGuardService } from './main/hotel-auth-guard.service';
import { HotelService } from './main/hotel.service';
import { HotelResolverService } from './main/hotel-resolver.service';
import { LoginGuardService } from './main/login-guard.service';
import { PaginationService } from './common/pagination.service';
import { ParkingsService } from './main/parkings.service';
import { PaymentsService } from './main/payments.service';
import { ReservationsService } from './main/reservations.service';
import { SettingsService } from './common/settings.service';
import { UsersService } from './main/users.service';

export {
    AuthService,
    HotelAuthGuardService,
    HotelService, HotelResolverService,
    LoginGuardService,
    PaginationService,
    ParkingsService,
    PaymentsService,
    ReservationsService,
    SettingsService,
    UsersService
};
